export default {
    SET_PROVEEDORES: (state, payload) => {
        state.proveedores = payload
    },
    SET_PROVEEDORES_FILTROS: (state, payload) => {
        state.proveedoresFiltros = payload
    },
    SET_TOTAL_PROVEEDORES: (state, payload) => {
        state.totalProveedores = payload
    },
    SET_PROVEEDORES_EXPORT: (state, payload) => {
        state.proveedoresExport = payload
    },
    SET_PROVEEDORES_FILTERS_EXPORT: (state, payload) => {
        state.proveedoresFiltersExport = payload
    }
}